import _get from 'lodash/get';
import MAPPING_PRESETS, {
  CollectionItem,
} from 'components/Mappings/CollectionMapping/MAPPING_PRESETS';

function sampleDataLookup(sampleUserData: any, mapping: any) {
  const collectionKey = mapping.source.split('.')[0];

  const collectionMapping = MAPPING_PRESETS.find((mp: CollectionItem) => mp.key === collectionKey);

  if (!collectionMapping) {
    return null;
  }

  const subSource = getSubSource({ collectionMapping, mapping });

  const defaultType = collectionMapping.types.find(i => i.isDefault);

  const collectionItemType = mapping.collectionItemType
    ? mapping.collectionItemType
    : defaultType
    ? defaultType.key
    : _get(collectionMapping, 'types[0]', '');

  const collection = _get(sampleUserData, collectionKey);

  let collectionItem;

  if (!Array.isArray(collection)) {
    return undefined;
  }

  if (mapping.collectionItemCustomType) {
    collectionItem = collection.find((item: any) => item.customType === mapping.collectionItemType);
  } else if (collectionItemType === 'primary') {
    collectionItem = collection.find((item: any) => item.primary === true);
  } else {
    collectionItem = collection.find((item: any) => item.type === collectionItemType);
  }

  return _get(collectionItem, subSource);
}

function getSubSource({ collectionMapping, mapping }: any) {
  const defaultSubSource = collectionMapping.itemProperties.find(
    (i: { key: string; isDefault: boolean }) => !!i.isDefault,
  );

  return (
    _get(mapping, `customProps.subSource`) ||
    mapping.source.split('.')[1] ||
    _get(defaultSubSource, 'key') ||
    ''
  );
}

export default sampleDataLookup;
